export const BAR_CHART_MARGIN = { top: 5, bottom: 30, left: 50, right: 0 }
export const BAR_CHART_HEIGHT = 300
